import {
  fetchDataAxios,
  fetchDataWithTokenAxios,
  fetchDataWithTokenForPdfAxios,
} from "./apiConfig";

//for passing payload  write code as getData = (path, payload)
// and use post method like post(path, payload)

export const getData = (path, headers) => {
  return fetchDataWithTokenAxios.get(path, headers);
};

export const getPdfData = (path) => {
  return fetchDataWithTokenForPdfAxios.get(path, {
    responseType: "arraybuffer",
  });
};

export const postData = (path, payload, headers = {}) => {
  return fetchDataAxios.post(path, payload, { headers });
};
// export const postData = (path, payload) => {
//   return fetchDataAxios.post(path, payload);
// };
export const postFormData = (path, payload) => {
  return fetchDataAxios.post(path, payload, {
    headers: { "Content-Type": "multipart/form-data" },
  });
};

// export const postUploadData = (path, payload) => {
//   return fetchUploadDataAxios.post(path, payload);
// };
export const postDataDownload = (path, payload) => {
  return fetchDataAxios.post(path, payload, { responseType: "blob" });
};
export const postExcelDownload = (path, payload) => {
  return fetchDataAxios.post(path, payload, { responseType: "arraybuffer" });
};
export const productCard1 = (path) => {
  return fetchDataAxios.get(path);
};
